'use strict';

angular.module('dashboard')
.controller('DashboardCtrl', function ($scope, Programme, seasons, programmes, languages) {

    $scope.programmes = programmes;
    $scope.seasons = seasons;

    var english = {
        id: 0,
        code: 'gb',
        name: 'English',
    };

    $scope.languages = [english];

    languages.forEach(function (l) {
        $scope.languages.push({
            id: l.id,
            code: l.code,
            name: l.name,
        });
    });

    $scope.selectedLanguage = english;

    $scope.changeSeason = function(season)
    {
        $scope.selectedSeason = season;
    };

    $scope.changeLanguage = function(language)
    {
        $scope.selectedLanguage = language;
    };

    function updateSeason()
    {
        var params = {
           where: {},
           sort: 'display_order'
        };

        if ($scope.selectedLanguage) {
            params.where.language_id = {
                '==': $scope.selectedLanguage.id
            };
        }

        if ($scope.selectedSeason) {
            params.where.season_id = {
                '==': $scope.selectedSeason.id
            };
        }

        Programme.findAll(params, {
            bypassCache: true
        }).then(function (programmes) {
            $scope.programmes = programmes;
        });
    }

    $scope.$watch('selectedSeason', function (newVal, oldVal)
    {
        if (newVal === oldVal) {
            return;
        }

        updateSeason();
    });

    $scope.$watch('selectedLanguage', function (newVal, oldVal)
    {
        if (newVal === oldVal) {
            return;
        }

        updateSeason();
    });

    $scope.selectedSeason = seasons.find(function (item) {
        return item.current === 1;
    });

    if ($scope.selectedSeason) {
        updateSeason();
    }

});
